module.exports = __webpack_public_path__ + "img/freight_yard4_1.afb07519.png";